export default __webpack_public_path__ + "static/media/tune-.be2c0672.png";